import api from "../axiosInstance";

export const getHelpAndGuides = async (payload) => {
  try {
    const response = await api.get(`/help-guide`);
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const AddHelpAndGuide = async (payload) => {
  try {
    const response = await api.post(`/help-guide`, {
      question: payload.question,
      answer: payload.answer,
    });
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const EditHelpAndGuide = async (payload) => {
  try {
    const response = await api.put(`/help-guide?id=${payload._id}`, {
      question: payload.question,
      answer: payload.answer,
    });
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const DeleteHelpAndGuide = async (payload) => {
  try {
    const response = await api.delete(`/help-guide?id=${payload._id}`);
    return response.data.data;
  } catch (err) {
    throw err;
  }
};
